/*
 * Module for the details of a mart/conversation transcript (Date, Id, TouchPoint...)
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/learner/learnerTranscriptModal/conversationTranscriptDetails/conversationTranscriptDetailsView",
], function (Marionette, Messenger, ConversationTranscriptDetailsView) {
  var ConversationTranscriptDetailsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "conversationTranscriptDetails";
      this.region = options.region;
      this.matchType = options.matchType;
    },
    show: function (transcript) {
      transcript.touchPoints = Messenger.reqres.request("kb:touchpoints");
      transcript.matchType = this.matchType; //keep the match type on the transcript to determine whether this is a "topic match" or "near miss"
      this.view = new ConversationTranscriptDetailsView.conversationTranscriptDetailsView({
        model: transcript,
      });
      this.view.on(
        "click:topic:match",
        function (intentId) {
          var topic = Messenger.reqres.request("topic", intentId); //load topic from server
          //fire a vent to show the topic
          Messenger.vent.trigger("show:topic", topic);
          Messenger.vent.trigger("show:mini:learner", true); //expand learner
          Messenger.vent.trigger("set:highlighted:transcript", transcript);
          //trigger closing the modal
          Messenger.vent.trigger("close:modal");
        },
        this,
      );
      this.showRegion(this.view);
    },
  });

  return ConversationTranscriptDetailsController;
});
